/**
 * api接口的统一出口
 */
//
import getLogin from "./login";
import getMenu from "./menu";
import getApp from "./app";
import getUser from "./user";
import getConfig from "./config";
import getPayouts from "./payouts";
import getAdn from "./adn";
import getAccessad from "./accessad";
import getAdLog from "./adlog";
import getBill from "./bill";
import getData from "./data";
import getChannel from "./channel";
import getAdmin from "./admin";
import getAppRules from "./app_rules";
import getSchedulers from "./schedulers";
import getTasks from "./tasks";
import getReport from "./report";
// 其他模块的接口……
// 导出接口
export default {
  getLogin,
  getMenu,
  getApp,
  getUser,
  getConfig,
  getPayouts,
  getAdn,
  getAccessad,
  getAdLog,
  getBill,
  getData,
  getChannel,
  getAdmin,
  getAppRules,
  getTasks,
  getSchedulers,
  getReport,
};
